module.exports = __webpack_public_path__ + "img/calculator.ea18bb55.png";